import React from 'react';
import { Switch } from 'react-router-dom';
import SignupPage from 'src/components/AppRoutes/SelfService/Signup';
import WrappedRoute from 'src/components/AppRoutes/WrappedRoute';
import SignupInfoPage from 'src/components/selfService/features/Signup/pages/SignupInfoPage/SignupInfoPage';

export const SignUpRoutes = (): JSX.Element => {
  return (
    <Switch>
      <WrappedRoute
        exact
        path="/corporate/signup/info"
        component={(): JSX.Element => <SignupInfoPage />}
      />
      <WrappedRoute
        exact
        path="/corporate/signup/step/:stepNumber"
        component={(): JSX.Element => <SignupPage />}
      />
    </Switch>
  );
};
